import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Redirect, useHistory } from "react-router-dom";
import {
  FaChalkboardTeacher,
  FaPlus,
  FaRedoAlt,
  FaUsers,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import BackButton from "../ChildComponent/BackButton";
import myToast from "../Utils/MyToast";
import MdlSelectSession from "../dialog/MdlSelectSession";
import MdlAddNewClass from "../dialog/MdlAddNewClass";
import MdlAddSection from "../dialog/MdlAddSection";
import MdlAddClassTeacher from "../dialog/MdlAddClassTeacher";
import MdlRenameClass from "../dialog/MdlRenameClass";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/certificate.css";

//Created By Cursor
const ClassSettings = () => {
  const history = useHistory();
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [isOpenAddSection, setIsOpenAddSection] = useState(false);
  const [isOpenAddNewClass, setIsOpenAddNewClass] = useState(false);
  const [isOpenAddClassTeacher, setIsOpenAddClassTeacher] = useState(false);
  const [isOpenRenameClass, setIsOpenRenameClass] = useState(false);
  const [loggedIn, setLoggedIn] = useState(true);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [sessionStatus, setSessionStatus] = useState("");
  const [mClassData, setMClassData] = useState([]);
  const [mClassBoard, setMClassBoard] = useState([]);
  const [mClassMedium, setMClassMedium] = useState([]);
  const [mFilteredClassSectionList, setMFilteredClassSectionList] = useState(
    []
  );
  const [mAllSection, setMAllSection] = useState([]);
  const [mStudentCount, setMStudentCount] = useState([]);
  const [mClassTeachers, setMClassTeachers] = useState([]);
  const [selectedBoardId, setSelectedBoardId] = useState("");
  const [selectedMediumId, setSelectedMediumId] = useState("");
  const [selectedClass, setselectedClass] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
      return;
    }

    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length > 0) {
      setSessionId(mSession[0].session_id);
      setSessionName(mSession[0].session_name);
      setSessionStatus(mSession[0].status);
    } else {
      setLoading(false);
    }
  }, []);

  //Created By Cursor
  const getClass = useCallback(async () => {
    if (!sessionId) return;
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getClassWithStudentCount.php`;

    try {
      const response = await axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: sessionId,
        },
      });
      const data = response.data;
      if (data.api_status === "OK") {
        const apiClass = Array.isArray(data.data.class) ? data.data.class : [];
        const apiBoard = Array.isArray(data.data.board) ? data.data.board : [];
        const apiMedium = Array.isArray(data.data.medium)
          ? data.data.medium
          : [];
        const apiAllSection = Array.isArray(data.data.all_section)
          ? data.data.all_section
          : [];
        const apiStudentCount = Array.isArray(data.data.student_count)
          ? data.data.student_count
          : [];
        const apiClassTeachers = Array.isArray(data.data.class_teachers)
          ? data.data.class_teachers
          : [];

        setMClassData(apiClass);
        setMClassBoard(apiBoard);
        setMClassMedium(apiMedium);
        setMAllSection(apiAllSection);
        setMStudentCount(apiStudentCount);
        setMClassTeachers(apiClassTeachers);
        setSelectedBoardId((prev) =>
          prev && apiBoard.some((b) => String(b.board_id) === String(prev))
            ? prev
            : apiBoard[0]?.board_id || ""
        );
        setSelectedMediumId((prev) =>
          prev && apiMedium.some((m) => String(m.medium_id) === String(prev))
            ? prev
            : apiMedium[0]?.medium_id || ""
        );
      } else {
        myToast.notify_warning(data.api_remark);
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
      myToast.notify_error("Failed to load class list");
    } finally {
      setLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    if (sessionId) {
      getClass();
    }
  }, [sessionId, getClass]);

  useEffect(() => {
    if (!selectedBoardId || !selectedMediumId || !mClassData.length) {
      setMFilteredClassSectionList([]);
      return;
    }

    const safeAllSection = Array.isArray(mAllSection) ? mAllSection : [];
    const safeStudentCount = Array.isArray(mStudentCount) ? mStudentCount : [];
    const safeTeachers = Array.isArray(mClassTeachers) ? mClassTeachers : [];

    const findTeacher = (classId, sectionId) => {
      const match = safeTeachers.find(
        (t) =>
          String(t.class_id) === String(classId) &&
          String(t.section_id) === String(sectionId)
      );
      return {
        class_teacher_id: match?.class_teacher_id || "",
        class_teacher_name: match?.class_teacher_name || "",
      };
    };

    const filtered = mClassData
      .filter(
        (item) =>
          String(item.board_id) === String(selectedBoardId) &&
          String(item.medium_id) === String(selectedMediumId)
      )
      .flatMap((item) => {
        const sections = safeAllSection.filter(
          (s) => String(s.class_id) === String(item.class_id)
        );
        return sections.length
          ? sections.map((s) => {
              const teacher =
                s.class_teacher_name || s.class_teacher_id
                  ? {
                      class_teacher_id: s.class_teacher_id || "",
                      class_teacher_name: s.class_teacher_name || "",
                    }
                  : findTeacher(item.class_id, s.section_id);
              return {
                ...item,
                ...s,
                session_id: s.session_id || item.session_id || sessionId,
                class_teacher_id: teacher.class_teacher_id,
                class_teacher_name:
                  teacher.class_teacher_name ||
                  findTeacher(item.class_id, s.section_id).class_teacher_name,
                student:
                  safeStudentCount.find(
                    (sc) =>
                      String(sc.class_id) === String(item.class_id) &&
                      String(sc.section_id) === String(s.section_id)
                  )?.total_student || 0,
              };
            })
          : [
              (() => {
                const teacher = findTeacher(item.class_id, "No");
                return {
                  ...item,
                  section_id: "No",
                  session_id: item.session_id || sessionId,
                  class_teacher_id: teacher.class_teacher_id,
                  class_teacher_name: teacher.class_teacher_name,
                  student:
                    safeStudentCount.find(
                      (sc) =>
                        String(sc.class_id) === String(item.class_id) &&
                        String(sc.section_id) === "No"
                    )?.total_student || 0,
                };
              })(),
            ];
      });

    setMFilteredClassSectionList(filtered);
  }, [
    selectedBoardId,
    selectedMediumId,
    mClassData,
    mAllSection,
    mStudentCount,
    mClassTeachers,
    sessionId,
  ]);

  const handleSessionDialog = () =>
    setIsOpenSessionDialog((prev) => !prev);

  const handleAddNewClass = (didSave) => {
    if (didSave === true) {
      setIsOpenAddNewClass(false);
      getClass();
      return;
    }
    setIsOpenAddNewClass((prev) => !prev);
  };

  const handleAddSection = (item) => {
    setIsOpenAddSection((prev) => !prev);
    if (item) setselectedClass(item);
  };

  const handleAddClassTeacher = (itemOrDidSave) => {
    if (itemOrDidSave && itemOrDidSave.class_id) {
      setselectedClass({
        ...itemOrDidSave,
        session_id: itemOrDidSave.session_id || sessionId,
        section_id:
          itemOrDidSave.section_id && itemOrDidSave.section_id !== "null"
            ? itemOrDidSave.section_id
            : "No",
      });
      setIsOpenAddClassTeacher(true);
      return;
    }
    setIsOpenAddClassTeacher(false);
    // refresh after save (true) or always when closing from dialog success path
    if (itemOrDidSave === true) {
      getClass();
    }
  };

  const handleRenameClass = (item) => {
    if (item && item.class_id) {
      setselectedClass(item);
      setIsOpenRenameClass(true);
      return;
    }
    setIsOpenRenameClass(false);
    getClass();
  };

  //Created By Cursor
  const handleDeleteSection = async (item) => {
    if (!item.section_id || item.section_id === "No") {
      myToast.notify_warning("No section to delete");
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to delete section "${item.section_name}"?`
      )
    ) {
      return;
    }

    try {
      setBusy(true);
      const mStaffData = SessionManager.getStaffDetails();
      const STAFF_ID = mStaffData?.staff_id || "";
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}DeleteClassSection.php`;

      const response = await axios.get(URL, {
        params: {
          staff_id: STAFF_ID,
          class_id: item.class_id,
          section_id: item.section_id,
          section_name: item.section_name,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
        },
      });
      const data = response.data;
      if (data.api_status === "OK") {
        myToast.notify_success("Section deleted successfully");
        await getClass();
      } else {
        myToast.notify_warning(data.api_remark || "Failed to delete section");
      }
    } catch (error) {
      console.error("Error deleting section:", error);
      myToast.notify_error("Something went wrong while deleting section");
    } finally {
      setBusy(false);
    }
  };

  //Created By Cursor
  const handleDeleteClass = async (item) => {
    const studentCount = Number(item?.student || 0);
    if (studentCount > 0) {
      myToast.notify_warning(
        "Cannot delete class with students. Move students first."
      );
      return;
    }

    const hasSections = item?.section_id && String(item.section_id) !== "No";
    if (hasSections) {
      myToast.notify_warning(
        "Cannot delete class with sections. Delete sections first."
      );
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to delete class "${item.class_name}"? This action cannot be undone.`
      )
    ) {
      return;
    }

    try {
      setBusy(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const mStaffData = SessionManager.getStaffDetails();
      const STAFF_ID = mStaffData?.staff_id;

      if (!SCHOOL_CODE || !STAFF_ID) {
        throw new Error("Session data not available");
      }

      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}DeleteClass.php`;
      const response = await axios.get(URL, {
        params: {
          staff_id: STAFF_ID,
          class_id: item.class_id,
          class_name: item.class_name,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
        },
        timeout: 10000,
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Class deleted successfully!");
        await getClass();
      } else {
        myToast.notify_error(
          response.data?.api_remark || "Failed to delete class"
        );
      }
    } catch (error) {
      console.error("Error deleting class:", error);
      myToast.notify_error("Something went wrong while deleting class");
    } finally {
      setBusy(false);
    }
  };

  const handleShiftStudent = (item) => {
    const hasSection = item?.section_id && String(item.section_id) !== "No";
    const classId = item?.class_id;
    const sectionId = hasSection ? item.section_id : "No";
    if (hasSection) {
      history.push(
        `/AdminMain/SectionShift/${classId}/${sectionId}/${sessionId}`
      );
    } else {
      history.push(`/AdminMain/ClassChange`);
    }
  };

  const hasSection = (item) =>
    item?.section_id && String(item.section_id) !== "No";

  const totalStudents = mFilteredClassSectionList.reduce(
    (sum, item) => sum + Number(item.student || 0),
    0
  );

  if (!loggedIn) return <Redirect to="/Login" />;
  if (loading && mClassData.length === 0) return <MyLoader />;

  return (
    <div className="content event-certificate cls-page">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="/AdminMain/Settings" style={{ color: COLORS.white }}>
                Settings
              </a>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Class Settings</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className={`page-card${busy ? " cls-busy" : ""}`}>
        <div className="header-section">
          <div className="header-content">
            <h5>Class Settings</h5>
            <small>
              Manage classes, sections, teachers and student shifts for{" "}
              {sessionName || "the selected session"}
            </small>
          </div>
          <div className="cls-header-actions">
            <div className="cls-header-stats">
              <div>
                <span>Classes</span>
                <strong>{mFilteredClassSectionList.length}</strong>
              </div>
              <div>
                <span>Students</span>
                <strong>{totalStudents}</strong>
              </div>
            </div>
            <button
              type="button"
              className="selection-button"
              onClick={handleAddNewClass}
              style={{
                background: "rgba(255,255,255,0.18)",
                boxShadow: "none",
              }}
            >
              <FaPlus />
              Add Class
            </button>
            <button
              type="button"
              className="selection-button"
              onClick={getClass}
              disabled={loading || busy}
              style={{
                background: "rgba(255,255,255,0.18)",
                boxShadow: "none",
              }}
            >
              <FaRedoAlt />
              Refresh
            </button>
            <div className="header-icon">
              <FaChalkboardTeacher />
            </div>
          </div>
        </div>

        <div className="cls-body">
          <div className="cls-toolbar">
            <div className="cls-toolbar-grid">
              <button
                type="button"
                className="cls-filter-tile cls-session-btn"
                onClick={handleSessionDialog}
              >
                <span className="cls-filter-icon">
                  <i className="fa fa-calendar" aria-hidden="true" />
                </span>
                <span className="cls-filter-text">
                  <span className="cls-filter-label">Session</span>
                  <strong>
                    {sessionName || "Select session"}
                    {sessionStatus ? (
                      <em className="cls-session-badge">{sessionStatus}</em>
                    ) : null}
                  </strong>
                </span>
                <i
                  className="fa fa-angle-right cls-filter-chevron"
                  aria-hidden="true"
                />
              </button>

              <label className="cls-filter-tile cls-field">
                <span className="cls-filter-icon">
                  <i className="fa fa-university" aria-hidden="true" />
                </span>
                <span className="cls-filter-text">
                  <span className="cls-filter-label">Board</span>
                  <select
                    value={selectedBoardId}
                    onChange={(e) => setSelectedBoardId(e.target.value)}
                  >
                    {mClassBoard.map((item) => (
                      <option key={item.board_id} value={item.board_id}>
                        {item.board_name}
                      </option>
                    ))}
                  </select>
                </span>
              </label>

              <label className="cls-filter-tile cls-field">
                <span className="cls-filter-icon">
                  <i className="fa fa-language" aria-hidden="true" />
                </span>
                <span className="cls-filter-text">
                  <span className="cls-filter-label">Medium</span>
                  <select
                    value={selectedMediumId}
                    onChange={(e) => setSelectedMediumId(e.target.value)}
                  >
                    {mClassMedium.map((item) => (
                      <option key={item.medium_id} value={item.medium_id}>
                        {item.medium_name}
                      </option>
                    ))}
                  </select>
                </span>
              </label>
            </div>
          </div>

          {loading ? (
            <div className="cls-loading-inline">
              <MyLoader />
            </div>
          ) : mFilteredClassSectionList.length === 0 ? (
            <div className="cls-empty">
              <i className="fa fa-th-large" />
              <h6>No classes found</h6>
              <p>
                Try another board/medium, or add a new class for this session.
              </p>
              <button
                type="button"
                className="selection-button"
                onClick={handleAddNewClass}
              >
                <FaPlus />
                Add New Class
              </button>
            </div>
          ) : (
            <div className="cls-grid">
              {mFilteredClassSectionList.map((item, index) => {
                const sectionExists = hasSection(item);
                const canDeleteClass =
                  !sectionExists && Number(item?.student || 0) === 0;
                const boardName =
                  item.board_name ||
                  mClassBoard.find(
                    (b) => String(b.board_id) === String(item.board_id)
                  )?.board_name ||
                  "Board";
                const mediumName =
                  item.medium_name ||
                  mClassMedium.find(
                    (m) => String(m.medium_id) === String(item.medium_id)
                  )?.medium_name ||
                  "Medium";
                return (
                  <div
                    key={`${item.class_id}-${item.section_id || "No"}-${index}`}
                    className="cls-card"
                  >
                    <div className="cls-card-head">
                      <div>
                        <h6>
                          {item.class_name}
                          {item.section_name ? ` · ${item.section_name}` : ""}
                        </h6>
                        <small className="cls-teacher-line">
                          <i className="fa fa-user" aria-hidden="true" />
                          {item.class_teacher_name
                            ? item.class_teacher_name
                            : "No class teacher"}
                        </small>
                      </div>
                      <div className="cls-card-head-right">
                        <small className="cls-meta-line">
                          {boardName} · {mediumName}
                        </small>
                        <span className="cls-count">
                          <FaUsers />
                          {item.student}
                        </span>
                      </div>
                    </div>

                    <div className="cls-card-actions">
                      <button
                        type="button"
                        className="cls-btn cls-btn-primary"
                        onClick={() => handleAddSection(item)}
                        title="Add Section"
                      >
                        <i className="fa fa-plus" aria-hidden="true" />
                        Section
                      </button>
                      <button
                        type="button"
                        className="cls-btn cls-btn-danger"
                        onClick={() => {
                          if (sectionExists) handleDeleteSection(item);
                          else handleDeleteClass(item);
                        }}
                        title={
                          sectionExists ? "Delete Section" : "Delete Class"
                        }
                        disabled={!sectionExists && !canDeleteClass}
                      >
                        <i className="fa fa-trash" aria-hidden="true" />
                        {sectionExists ? "Delete Sec." : "Delete"}
                      </button>
                      <button
                        type="button"
                        className="cls-btn cls-btn-info"
                        onClick={() => handleShiftStudent(item)}
                        title="Shift Students"
                      >
                        <i className="fa fa-exchange" aria-hidden="true" />
                        Shift
                      </button>
                      <button
                        type="button"
                        className="cls-btn cls-btn-muted"
                        onClick={() => handleAddClassTeacher(item)}
                        title="Add Class Teacher"
                      >
                        <i className="fa fa-user-plus" aria-hidden="true" />
                        Teacher
                      </button>
                      <button
                        type="button"
                        className="cls-btn cls-btn-warn"
                        onClick={() => handleRenameClass(item)}
                        title="Rename Class"
                      >
                        <i className="fa fa-edit" aria-hidden="true" />
                        Rename
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {isOpenSessionDialog && (
        <MdlSelectSession
          action={handleSessionDialog}
          action2={(id, name, status) => {
            setSessionId(id);
            setSessionName(name);
            setSessionStatus(status);
            handleSessionDialog();
          }}
        />
      )}

      {isOpenAddSection && (
        <MdlAddSection
          actionClose={handleAddSection}
          action2={async ({ section_id, section_name }) => {
            try {
              setBusy(true);
              const mStaffData = SessionManager.getStaffDetails();
              const STAFF_ID = mStaffData?.staff_id || "";
              const SCHOOL_CODE = SessionManager.getSchoolCode();
              const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}AddClassSection.php`;

              const response = await axios.get(URL, {
                params: {
                  staff_id: STAFF_ID,
                  class_id: selectedClass?.class_id || "",
                  section_id,
                  section_name,
                  school_code: SCHOOL_CODE,
                },
              });
              const data = response.data;
              if (data.api_status === "OK") {
                myToast.notify_success("Section added successfully");
                await getClass();
                handleAddSection();
              } else {
                myToast.notify_warning(
                  data.api_remark || "Failed to add section"
                );
              }
            } catch (error) {
              console.error("Error adding section:", error);
              myToast.notify_error("Something went wrong while adding section");
            } finally {
              setBusy(false);
            }
          }}
        />
      )}

      {isOpenAddNewClass && (
        <MdlAddNewClass
          actionClose={() => handleAddNewClass(false)}
          action2={() => handleAddNewClass(true)}
          sessionId={sessionId}
        />
      )}
      {isOpenAddClassTeacher && (
        <MdlAddClassTeacher
          actionClose={handleAddClassTeacher}
          selectedClass={selectedClass}
          sessionId={sessionId}
        />
      )}
      {isOpenRenameClass && (
        <MdlRenameClass
          actionClose={handleRenameClass}
          action2={handleRenameClass}
          selectedClass={selectedClass}
        />
      )}

      <style>{`
        .cls-page .page-card { margin: 0 0 24px; }
        .cls-page .page-card.cls-busy { opacity: 0.72; pointer-events: none; }
        .cls-page .header-section {
          min-height: 56px;
          padding: 8px 20px;
        }
        .cls-page .header-content h5 { font-size: 17px; }
        .cls-page .header-content small { font-size: 12px; margin-top: 2px; }
        .cls-page .header-icon { font-size: 28px; }
        .cls-header-actions {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .cls-header-actions .selection-button {
          padding: 7px 12px;
          font-size: 13px;
        }
        .cls-header-stats {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-right: 4px;
          padding: 4px 12px;
          border-radius: 10px;
          background: rgba(255,255,255,0.16);
        }
        .cls-header-stats span {
          display: block;
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          opacity: 0.9;
          font-weight: 700;
          line-height: 1.1;
        }
        .cls-header-stats strong {
          display: block;
          font-size: 16px;
          font-weight: 700;
          line-height: 1.15;
          color: #fff;
        }
        .cls-body { padding: 16px 20px 24px; }
        .cls-toolbar {
          margin-bottom: 16px;
          padding: 12px;
          border-radius: 14px;
          background: linear-gradient(180deg, #f0f9ff 0%, #f8fafc 100%);
          border: 1px solid #dbeafe;
        }
        .cls-toolbar-grid {
          display: grid;
          grid-template-columns: 1.35fr 1fr 1fr;
          gap: 10px;
          align-items: stretch;
        }
        .cls-filter-tile {
          display: flex;
          align-items: center;
          gap: 12px;
          min-height: 64px;
          margin: 0;
          padding: 10px 14px;
          text-align: left;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          background: #fff;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
          transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
        }
        .cls-filter-tile:hover {
          border-color: #93c5fd;
          box-shadow: 0 6px 16px rgba(2, 136, 209, 0.1);
          transform: translateY(-1px);
        }
        .cls-session-btn {
          cursor: pointer;
          width: 100%;
          border-left: 3px solid #0288d1;
        }
        .cls-filter-icon {
          flex: 0 0 auto;
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
          color: #0288d1;
          font-size: 15px;
        }
        .cls-filter-text {
          flex: 1 1 auto;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 3px;
        }
        .cls-filter-label {
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #64748b;
          font-weight: 700;
          line-height: 1;
        }
        .cls-session-btn strong {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
          color: #0f172a;
          font-size: 14px;
          font-weight: 700;
          line-height: 1.25;
        }
        .cls-session-badge {
          font-style: normal;
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #0369a1;
          background: #e0f2fe;
          border: 1px solid #bae6fd;
          border-radius: 999px;
          padding: 2px 8px;
        }
        .cls-filter-chevron {
          color: #94a3b8;
          font-size: 16px;
        }
        .cls-field select {
          width: 100%;
          height: 28px;
          border: none;
          outline: none;
          padding: 0;
          margin: 0;
          background: transparent;
          color: #0f172a;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          appearance: none;
          -webkit-appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%230288d1' d='M1.4.6L6 5.2 10.6.6 12 2 6 8 0 2z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 2px center;
          padding-right: 18px;
        }
        .cls-field select:focus { outline: none; }
        .cls-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 14px;
        }
        .cls-card {
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          background: #fff;
          overflow: hidden;
          box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }
        .cls-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
        }
        .cls-card-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          padding: 8px 12px;
          background: linear-gradient(135deg, #0288d1 0%, #039be5 100%);
          color: #fff;
        }
        .cls-card-head h6 {
          margin: 0;
          font-size: 14px;
          font-weight: 700;
          color: #fff;
          line-height: 1.25;
        }
        .cls-card-head small {
          display: block;
          margin-top: 2px;
          opacity: 0.92;
          font-size: 11px;
          line-height: 1.2;
        }
        .cls-teacher-line {
          font-weight: 600;
        }
        .cls-teacher-line i {
          margin-right: 4px;
          opacity: 0.9;
          font-size: 10px;
        }
        .cls-meta-line {
          opacity: 0.9 !important;
          font-size: 10px !important;
          margin: 0 !important;
          text-align: right;
          white-space: nowrap;
        }
        .cls-card-head-right {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 4px;
          flex: 0 0 auto;
        }
        .cls-count {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: rgba(255,255,255,0.18);
          border-radius: 999px;
          padding: 4px 8px;
          font-weight: 700;
          font-size: 12px;
          white-space: nowrap;
        }
        .cls-card-actions {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 8px;
          padding: 12px;
          background: #f8fafc;
        }
        .cls-btn {
          border: 1.5px solid transparent;
          border-radius: 9px;
          background: #fff;
          padding: 8px 6px;
          font-size: 12px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.15s ease;
        }
        .cls-btn i { margin-right: 5px; }
        .cls-btn:disabled {
          opacity: 0.45;
          cursor: not-allowed;
        }
        .cls-btn-primary { color: #0288d1; border-color: #0288d1; }
        .cls-btn-primary:hover:not(:disabled) { background: #0288d1; color: #fff; }
        .cls-btn-danger { color: #dc3545; border-color: #dc3545; }
        .cls-btn-danger:hover:not(:disabled) { background: #dc3545; color: #fff; }
        .cls-btn-info { color: #0ea5e9; border-color: #0ea5e9; }
        .cls-btn-info:hover:not(:disabled) { background: #0ea5e9; color: #fff; }
        .cls-btn-muted { color: #64748b; border-color: #94a3b8; }
        .cls-btn-muted:hover:not(:disabled) { background: #64748b; color: #fff; }
        .cls-btn-warn { color: #a16207; border-color: #f59e0b; grid-column: span 2; }
        .cls-btn-warn:hover:not(:disabled) { background: #f59e0b; color: #212529; }
        .cls-empty {
          text-align: center;
          padding: 48px 20px;
          color: #64748b;
          border: 1px dashed #cbd5e1;
          border-radius: 12px;
          background: #f8fafc;
        }
        .cls-empty i {
          font-size: 34px;
          color: #94a3b8;
          margin-bottom: 10px;
        }
        .cls-empty h6 {
          margin: 0 0 6px;
          color: #0f172a;
          font-weight: 700;
        }
        .cls-empty p { margin: 0 0 14px; }
        .cls-loading-inline {
          min-height: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        @media (max-width: 1100px) {
          .cls-toolbar-grid { grid-template-columns: 1fr 1fr; }
          .cls-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        @media (max-width: 700px) {
          .cls-toolbar-grid,
          .cls-grid { grid-template-columns: 1fr; }
          .cls-header-actions { flex-wrap: wrap; justify-content: flex-end; }
          .cls-btn-warn { grid-column: span 1; }
          .cls-card-actions { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
      `}</style>
    </div>
  );
};

export default ClassSettings;
